import { useEffect, useState, useContext } from "react";
import {
  collection, query, where, orderBy, limit, onSnapshot,
} from "firebase/firestore";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { AuthContext } from "../../store/AuthContext";
import { db } from "../../firebase";
import "./dashboard.scss";

const formatWhen = (ts) => {
  const d = ts?.toDate ? ts.toDate() : ts instanceof Date ? ts : null;
  if (!d) return "";
  return format(d, "d MMM HH:mm", { locale: es });
};

const UnreadNotificationsList = () => {
  const { currentService, currentUser } = useContext(AuthContext);
  const serviceId = currentService?.id;
  const email = currentUser?.email;
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!serviceId || !email) return;
    const ref = collection(db, "servicios", serviceId, "notificaciones_dashboard");
    const q = query(
      ref,
      where("destinatario", "in", [email, "todos"]),
      where("leida", "==", false),
      orderBy("fecha", "desc"),
      limit(5),
    );
    const unsub = onSnapshot(
      q,
      (snap) => {
        setItems(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoaded(true);
      },
      (err) => {
        console.error("UnreadNotificationsList error:", err);
        setLoaded(true);
      },
    );
    return () => unsub();
  }, [serviceId, email]);

  return (
    <div className="info-card unread-notifications">
      <div className="info-card-header">
        <Bell size={18} />
        <h3>Notificaciones sin leer</h3>
        {items.length > 0 && <span className="badge-count">{items.length}</span>}
      </div>
      <ul>
        {items.map((n) => (
          <li key={n.id} className="notif-item">
            <div className="notif-main">
              <span className="notif-title">{n.titulo || "Sin título"}</span>
              <span className="notif-message">{n.mensaje || ""}</span>
            </div>
            <span className="notif-when">{formatWhen(n.fecha)}</span>
          </li>
        ))}
        {loaded && items.length === 0 && (
          <li className="empty">Todo al día — sin notificaciones pendientes.</li>
        )}
        {!loaded && <li className="empty">Cargando…</li>}
      </ul>
      <div className="info-card-footer">
        <Link to="/notificaciones-internas">Ver todas →</Link>
      </div>
    </div>
  );
};

export default UnreadNotificationsList;
